import React from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import styles from './styles.module.scss'
import planImage from '../../../assets/img/plan.png'
import taskImage from '../../../assets/img/task.png'
import BreadCrumbs from '../../../assets/BreadCrumbs'



// --- mock-данные для верстки ---
const lesson = {
  date: '16.11.2025',
  group: '2-127',
  discipline: 'Военно-профессиональная практика (практика в несении внутренней и караульной служб)',
}

const CurrentLesson = () => {
  
  const history = useHistory();
  const { pathname } = useLocation()
  
  const goTo = (page) => () => history.push(`${pathname}/${page}`)

  const breadcrumbsData = [
    { label: 'Журнал учета учебных занятий', to: '/journal' },
    { label: lesson.date },
  ]

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <BreadCrumbs data={breadcrumbsData} />

        <h1 className={styles.title}>Занятие {lesson.date}</h1>

        <div className={styles.lessonMeta}>
          <span>
            <span className={styles.metaLabel}>Группа</span> {lesson.group}
          </span>
          <span>
            <span className={styles.metaLabel}>Дисциплина</span> {lesson.discipline}
          </span>
        </div>

        <div className={styles.lessonCards}>
          <button type="button" className={styles.lessonCard} onClick={goTo('plan')}>
            <span className={styles.lessonCardTitle}>План проведения занятия</span>
            <img src={planImage} alt="" className={styles.lessonCardIcon} />
          </button>
          <button type="button" className={styles.lessonCard} onClick={goTo('homework')}>
            <span className={styles.lessonCardTitle}>Задание на СР</span>
            <img src={taskImage} alt="" className={styles.lessonCardIcon} />
          </button>
        </div>
      </div>
    </div>
  )
}

export default CurrentLesson
